export const products = [
  {
    id: 1,
    slug: "milan-bazar",
    title: "Milan Bazar",
    price: 355,
    image: "/book/milan bazar.png",
    description:
      "A practical guide designed to help readers understand the Milan Bazar market through number patterns, charts, analysis, and strategic insights. Intended for educational and reference purposes only.",
  },
  {
    id: 2,
    slug: "kalyan-bazar",
    title: "Kalyan Bazar",
    price: 355,
    image: "/book/kalyan bazar.png",
    description:
      "Provides structured information, number analysis, charts, and practical reference material for understanding the Kalyan Bazar market. For educational and reference purposes only.",
  },
  {
    id: 3,
    slug: "sridevi-bazar",
    title: "Sridevi Bazar",
    price: 355,
    image: "/book/sridevi bazar.png",
    description:
      "Offers easy-to-understand analysis, charts, number patterns, and reference material for the Sridevi Bazar market. For educational purposes only.",
  },
  {
    id: 4,
    slug: "madhur-bazar",
    title: "Madhur Bazar",
    price: 355,
    image: "/book/madhur bazar.png",
    description:
      "Presents market analysis, charts, and number references in a simple and organized format. Intended for educational and reference purposes only.",
  },
  {
    id: 5,
    slug: "supreme-bazar",
    title: "Supreme Bazar",
    price: 355,
    image: "/book/supreme bazar.png",
    description:
      "A comprehensive reference guide featuring market analysis, charts, number patterns, and strategic insights. For educational only.",
  },
  {
    id: 6,
    slug: "time-bazar",
    title: "Time Bazar",
    price: 355,
    image: "/book/time bazar.png",
    description:
      "Provides organized reference material, charts, number patterns, and analytical information to help readers understand the Time Bazar market. Educational purposes only.",
  },
  {
    id: 7,
    slug: "rajdhani-bazar",
    title: "Rajdhani Bazar",
    price: 355,
    image: "/book/rajdhani bazar.png",
    description:
      "Offers valuable reference material including charts, number analysis, and market insights. For educational and reference purposes only.",
  },
  {
    id: 8,
    slug: "main-bazar",
    title: "Main Bazar",
    price: 355,
    image: "/book/main bazar.png",
    description:
      "A practical reference guide containing number patterns, charts, market analysis, and strategic information. Intended for educational only.",
  },
  {
    id: 9,
    slug: "andhra-bazar",
    title: "Andhra Bazar",
    price: 355,
    image: "/book/andhra bazar.png",
    description:
      "A practical guide designed to help readers understand the Andhra Bazar market with clear analysis, number patterns, charts, and strategic insights. Intended for educational and reference purposes only.",
  },
];
